import { createCustomEnum } from "./customEnum";

export type TerminalSolutionTypesKeys =
	| "file_build"
	| "terminal"
	| "gateway"
	| "point_of_sale";

const TerminalSolutionTypes = createCustomEnum({
	FileBuildOnly: {
		name: "file_build",
		value: "file_build",
		displayName: "File Build Only (No Equipment Identified)",
	},
	Terminal: {
		name: "terminal",
		value: "terminal",
		displayName: "Terminal",
	},
	Gateway: {
		name: "gateway",
		value: "gateway",
		displayName: "Gateway",
	},
	PointOfSale: {
		name: "point_of_sale",
		value: "point_of_sale",
		displayName: "Point Of Sale",
	},
});

export default TerminalSolutionTypes;
